var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.currentSubscription || _vm.newSubscription
      ? _c(
          "div",
          {
            staticClass: "container",
            attrs: { "data-test-hook": "upgrade-to-multi-home-modal" }
          },
          [
            _vm.currentSubscription?.renewalDate
              ? _c(
                  "b-row",
                  {
                    staticClass: "mb-3 text-center",
                    attrs: { "no-gutters": "" }
                  },
                  [
                    _c("h5", { staticClass: "mx-auto header" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t("xToReceivePremiumFeaturesYouMustUpgrade")
                        )
                      )
                    ]),
                    _c("p", { staticClass: "upgrade-desc" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t("xWeWillApplyAProratedCredit", {
                              0: _vm.getCurrencyString(
                                _vm.selectedNewSubscription?.cost
                              ),
                              1: _vm
                                .$moment(_vm.currentSubscription.renewalDate)
                                .format(_vm.$t("xShortDate"))
                            })
                          ) +
                          " "
                      )
                    ])
                  ]
                )
              : _vm._e(),
            _c(
              "b-row",
              { attrs: { "no-gutters": "" } },
              [
                _c(
                  "b-col",
                  { staticStyle: { width: "100%" }, attrs: { cols: "0" } },
                  [
                    _c("SubscriptionUpgradeYearlyMonthlyCard", {
                      attrs: {
                        "subscription-product": _vm.newSubscription,
                        "apparatuses-to-upgrade": _vm.currentApparatuses,
                        "apparatuses-to-add": _vm.newApparatuses,
                        "is-new-plan": true
                      },
                      on: { setSelectedProduct: _vm.setSelectedProduct }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "b-row",
              { staticClass: "mt-3", attrs: { "no-gutters": "" } },
              [
                _c(
                  "b-col",
                  { attrs: { cols: "12" } },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "w-100 btn btn-primary",
                        attrs: {
                          variant: "warning",
                          "data-test-hook":
                            "upgrade-to-multi-home-modal-button-continue"
                        },
                        on: {
                          click: function($event) {
                            return _vm.$emit("openPayment")
                          }
                        }
                      },
                      [
                        _vm._v(" " + _vm._s(_vm.$t("xUpgradeNow")) + " "),
                        _vm.paying
                          ? _c("b-spinner", { staticClass: "ml-2" })
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "b-row",
              { staticClass: "mt-3" },
              [
                _c("b-col", { staticClass: "text-center" }, [
                  _c("p", { staticClass: "text-small legal-text" }, [
                    _vm._v(
                      "*" +
                        _vm._s(
                          _vm.$t(
                            "xPushNotificationsAreAvailableWithInstallation"
                          )
                        )
                    )
                  ])
                ])
              ],
              1
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }